import { render } from "./BuscadorIncidencias.vue?vue&type=template&id=9382c8b2&scoped=true"
import script from "./BuscadorIncidencias.vue?vue&type=script&lang=js"
export * from "./BuscadorIncidencias.vue?vue&type=script&lang=js"

import "./BuscadorIncidencias.vue?vue&type=style&index=0&id=9382c8b2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9382c8b2"]])

export default __exports__